import React, { Fragment, useEffect, useState } from "react";

const AboutUs = () => {
  
  let mobileviewinitial = window.innerWidth > 770 ? false : true;
  const [ismobileview, setismobileview] = useState(mobileviewinitial);
  
  useEffect(() => {
    function handleresize() {
      if (window.innerWidth > 770) {
        setismobileview(false);
      } else {
        setismobileview(true);
      }
    }
    window.addEventListener("resize", handleresize);
    return () => {
      window.removeEventListener("resize", handleresize);
    };
  }, []);

  return (
    <Fragment>
        <section id="product">
            <div className="section-title mt50" data-wow-delay="1s">
              <h2>About Us</h2>
            </div>
            <div className="textAboutUs">
                <li>Kabra Logitech Private Limited provides an efficient and cost-effective solution, helping businesses save time and resources. </li>
                <li>We automate and streamline logistics processes by providing businesses with an efficient ERP solution. </li>
                <li>With over two decades of experience in the logistics industry, Kabra Logitech is your go-to choice for innovative and effective ERP solutions.</li>
                <li>Our company's core product, «TapTap» helps businesses manage their inventory, shipping, and tracking information in a single platform.</li>
            </div>

            <div className="containerAbout">
              <div className="imageAbout">
              <img src="https://taptap.in/img/tap8.png" alt="" />
              </div>
            <div className="contentAbout">
            <h4 className="display-4">TapTap</h4>
            <p>TAP TAP- An ERP software that takes care of the needs of all the agents. One can track the route of their logistics services along with the income and expenses. This would help the client in having all the data in one place making work hassle-free.</p>
            <a href="taptap.html" className="btn btn-primary">Learn More</a>
            </div>
            </div>
            
            <hr className="hr mt50"/>
            
            <div className="col-xl-12 text-center mb-4 mt50 textAboutUs">
                <div className="service-title">
                    <h4>Our Features</h4>
                </div>
            </div>
            
            <div className="row textAboutUs">
                <div className="col-lg-4 col-md-6 text-center mb-3">
                    <div className="service-wrap">
                        <div className="service-icon">
                          <i className="fa fa-globe"></i>
                        </div>
                        <h4>Boosting productivity</h4>
                        <p>By utilizing ERP rather than paper-based processes, productivity is enhanced. </p>
                        <a href="#">Read More</a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 text-center mb-3">
                    <div className="service-wrap">
                        <div className="service-icon">
                            <i className="far fa-chart-bar"></i>
                        </div>
                        <h4>Saves time and resources</h4>
                        <p>By performing all of the tasks electronically, you can save time and energy while increasing efficiency.</p>
                        <a href="#">Read More</a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 text-center mb-3">
                    <div className="service-wrap">
                        <div className="service-icon">
                            <i className="fas fa-database"></i>
                        </div>
                        <h4>Concentrating technique</h4>
                        <p>Concentrating the technique allows for higher performance and efficiency.</p>
                        <a href="#">Read More</a>
                    </div>
                </div>
            </div>
            
            <hr className="hr mt50"/>
            
            <div className="row heading textAboutUs">
              <div className="col-md-6 col-md-offset-3">
                <h2 className="text-center bottom-line">Meet Our Team</h2>
              </div>
            </div>

            <div className="row team-row textAboutUs">

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member text-center">
                  <div className="team-img">
                    <img src="http://www.kabralogitech.in/images/kabra.jpg" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">
                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/chintan-kabra-10780288/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Chintan Kabra</h6>
                  <span>Chief Executive Officer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member text-center">
                  <div className="team-img">
                    <img src="http://deothemes.com/envato/enigma/html/img/team_2.jpg" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/jaypatel2504/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Jay Patel</h6>
                  <span>Full Stack developer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="https://media-exp1.licdn.com/dms/image/C4D03AQEhIXa35hhbSg/profile-displayphoto-shrink_200_200/0/1642303641398?e=1668643200&v=beta&t=oYNlnB-fG0fqJxhami1knRl3aXaU7T2Lno7AUjwdG7k" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/adityapanchal/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Aditya Panchal</h6>
                  <span>Full Stack developer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="https://media-exp1.licdn.com/dms/image/C5603AQHJbpq9EOqZSQ/profile-displayphoto-shrink_200_200/0/1631288082219?e=1668643200&v=beta&t=4C-E53-SdIKuPJuBVPDy63yH1hAcj-ltYwM-UkqvaMw" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/gruhit-patel-3919891ab/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Gruhit Patel</h6>
                  <span>Back-End Developer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="http://deothemes.com/envato/enigma/html/img/team_3.jpg" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="#"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Darshan Mangroliya</h6>
                  <span>React Js Developer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="https://media-exp1.licdn.com/dms/image/D4D35AQHprGlXS63meQ/profile-framedphoto-shrink_200_200/0/1654150328900?e=1663675200&v=beta&t=WyCdE6ARktDK3vmXe4uYwE6nrVrzcZV3M2CSuzE7120" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/tanay-patil-9094b7169/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Tanay Patil</h6>
                  <span>React Js Developer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="https://media-exp1.licdn.com/dms/image/C4D03AQEkwc6lyYJXaQ/profile-displayphoto-shrink_200_200/0/1662817590689?e=1668643200&v=beta&t=P0eNF9WcvfjAT41Dj613BEOGEN6cNlaOcTUT4TNaSvk" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/prashant-bhatiya/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Prashant Bhatiya</h6>
                  <span>React Js Developer</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="https://media-exp1.licdn.com/dms/image/C4E03AQFBSEgoC0CwxQ/profile-displayphoto-shrink_200_200/0/1646130324163?e=1668643200&v=beta&t=Vg4lYZtPXhoBMMtegbyk4IQBwsYRrcl9XJqmoW0RvNQ" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/khushi-pancholi-457b23232/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Khushi Pancholi</h6>
                  <span>HR Executive</span>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 team-wrap mb10">
                <div className="team-member last text-center">
                  <div className="team-img">
                    <img src="https://media-exp1.licdn.com/dms/image/C5603AQHK_MzyKHUwFw/profile-displayphoto-shrink_200_200/0/1603014883315?e=1668643200&v=beta&t=Vnwnk9ArjV5O2wo9iHrbuEi-_Lwr7or4HZ6OdPZtZ5w" alt="" />
                    <div className="overlay">
                      <div className="team-details text-center">

                        <div className="socials mt-20">
                          <a target="_blank" href="https://www.linkedin.com/in/dhruvangi-acharya-b38a08165/"><i className="fa fa-linkedin"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-twitter"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-google-plus"></i></a>
                          <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 className="team-title">Dhruvangi Acharya</h6>
                  <span>Marketing Intern</span>
                </div>
              </div>
            </div>
        </section>
        {ismobileview && 
          <div>
            <div className='footerHomePageDiv'>
              <div style={{border:"0.2px solid tranparent"}}>
                  <ul className="company-social" style={{textAlign:"center"}}>
                      <li className="social-facebook">
                          <a href="https://www.facebook.com/KabraExpressLogistics">
                              <i className="fa fa-facebook"></i>
                          </a>
                      </li>
                      <li className="social-twitter">
                          <a href="https://www.linkedin.com/company/kabra-express-logistics-private-limited/">
                              <i className="fa fa-linkedin"></i>
                          </a>
                      </li>
                      <li className="social-youtube">
                          <a href="https://www.instagram.com/kabra.express/">
                              <i className="fa fa-instagram"></i>
                          </a>
                      </li>
                      <li className="social-youtube">
                          <a href="https://www.youtube.com/channel/UCt4wx_zJAyQ-el--Jy3iurQ">
                              <i className="fab fa-youtube"></i>
                          </a>
                      </li>

                      <li className="social-twitter">
                          <a href="#">
                              <i className="fa fa-twitter"></i>
                          </a>
                      </li>
                  </ul>
              </div>
              
              <div className="col-sm-6 col-md-6 text-center poweredByText">
                <strong>
                    Powered by{" "}
                    <img src="https://img.icons8.com/bubbles/40/000000/light-on.png" />{" "}
                    Kabra Express Logistics Pvt. Ltd.
                </strong>
              </div>
              {/* <a href="#" className="scrollup">
                  <i className="fa fa-angle-up active"></i>
              </a> */}
            </div>
          </div>
        }
    </Fragment>
  );
};

export default AboutUs;
